import type { FormInstance } from 'antd';
import { Button, Form } from 'antd';
import Modal from 'antd/es/modal/Modal';
import type { ReactNode } from 'react';

type UnpublishedModalProps = {
  children: ReactNode;
  setIsDetailModalOpen: (val: boolean) => void;
  isDetailModalOpen: boolean;
  title: string;
  isDisabled: boolean;
  form: FormInstance;
  handleSubmit: ({ publish }: { publish: boolean }) => void;
};

export const UnpublishedModal = ({
  children,
  isDetailModalOpen,
  setIsDetailModalOpen,
  title,
  isDisabled,
  form,
  handleSubmit,
}: UnpublishedModalProps) => {
  return (
    <Modal
      title={title}
      centered
      open={isDetailModalOpen}
      onCancel={() => setIsDetailModalOpen(false)}
      footer={[
        <Button
          size="middle"
          type="ghost"
          onClick={() => setIsDetailModalOpen(false)}
        >
          Cancel
        </Button>,
        <Button
          size="middle"
          type={isDisabled ? 'ghost' : 'primary'}
          onClick={() => {
            setIsDetailModalOpen(false);
            handleSubmit({ publish: false });
          }}
          disabled={isDisabled}
        >
          Unpublish
        </Button>,
      ]}
    >
      <Form form={form}>{children}</Form>
    </Modal>
  );
};
